import React, {useMemo} from 'react'
import { Toaster, ToasterProps } from 'react-hot-toast'
import { Constants } from "@sendum/core";

export const CustomToaster = (props: ToasterProps) => {

    const errorIcon = useMemo(()=> {
        if (!process.env.REACT_APP_NAME) {
            return undefined;
        }

        if ([Constants.APP_NAME.IFRAME].includes(process.env.REACT_APP_NAME)) {
            return null;
        }

        return undefined;
    },[])

    return (
        <Toaster position="top-right" {...props} toastOptions={{
            error: {
                className: "customToaster_error",
                icon: errorIcon
            },
        }}/>
    )
}